import { GetCorporateClubExtract } from 'services/api/corporate-club/types';

export const corporateClubExtractMock: GetCorporateClubExtract = {
  id: '1-27NHBDJY',
  avaliablePlans: '120',
  hasData: false,
  activePlans: '98',
  status: 'Active',
  memberNameVoeBiz: 'O VALE DO SILÊNCIO SA',
  years: [],
};
